import React, { memo } from 'react'

import ChangeEmailForm from '@v4/components/common/Form/ChangeEmailForm'
import PropTypes from 'prop-types'
import { Slide, Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import PageMetaData from '@v4/utils/data/PageMetaData'
import PopupModal from '../../components/PopupModal'
import { useChangeEmail } from './ChangeEmail.hooks'

const ChangeEmail = props => {
	const [
		{
			open,
			buttonText,
			title,
			placeholderColor,
			showMessage,
			titleEditable,
			buttonTextConfig,
			titleConfig,
			buttonTextEditable,
			titleKey,
			buttonTextKey,
		},
		{
			handleButtonClick,
			handleClose,
			handleTitleClick,
			handleCloseMessage,
			handleSuccess,
			handleTitleChange,
			handleButtonTextChange,
		},
	] = useChangeEmail(props)

	return (
		<>
			<PopupModal className="popup-modal-email" open={open} onClose={handleClose}>
				<ChangeEmailForm
					className="change-email-form"
					title={title}
					titleConfig={titleConfig}
					titleEditable={titleEditable}
					onTitleChange={handleTitleChange}
					buttonText={buttonText}
					placeholderColor={placeholderColor}
					usePaperColors
					onSuccess={handleSuccess}
					onTitleClick={handleTitleClick}
					onButtonClick={handleButtonClick}
					buttonTextEditable={buttonTextEditable}
					buttonTextConfig={buttonTextConfig}
					onButtonTextChange={handleButtonTextChange}
					titleKey={titleKey}
					buttonTextKey={buttonTextKey}
				/>
			</PopupModal>
			<Snackbar
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={showMessage}
				autoHideDuration={5000}
				TransitionComponent={Slide}
				onClose={handleCloseMessage}
			>
				<MuiAlert severity="success" onClose={handleCloseMessage}>
					Details successfully updated!
				</MuiAlert>
			</Snackbar>
		</>
	)
}

ChangeEmail.propTypes = {
	metaData: PropTypes.shape({
		placeholderColor: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(ChangeEmail)
